import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata üle tänased parimad pakkumised

  <span style="color:#85c1dc;">**FI:**</span>
  Ostoskori yllättäen tyhjä? Kirjaudu sisään, sillä ON24-asiakkaan ostoskori säilyy tallennettuna

  <span style="color:#85c1dc;">**RU:**</span>
  Корзина неожиданно пуста? Авторизуйтесь, ведь корзина постоянного покупателя всегда сохраняется.
*/
/* @__NO_SIDE_EFFECTS__ */
const m972 = msg(
  mf`Vaata üle tänased parimad pakkumised`,
  mf`Ostoskori yllättäen tyhjä? Kirjaudu sisään, sillä ON24-asiakkaan ostoskori säilyy tallennettuna`,
  mf`Корзина неожиданно пуста? Авторизуйтесь, ведь корзина постоянного покупателя всегда сохраняется.`,
)

export { m972 as 'w.basket.empty.second.title' }